/** @jsx jsx */
import { jsx, Box, useColorMode } from 'theme-ui'
import { motion } from 'framer-motion'
import { useMapboxContext } from '../useMapboxContext'
import { Button } from 'components/buttons/Button'

const ZoomControl = React.forwardRef(({ children, type = 'plus' }, ref) => {
  const { map, zoom } = useMapboxContext()
  const handleClick = () => {
    const newZoom =
      type === 'plus' ? map.current.getZoom() + 1 : map.current.getZoom() - 1
    map.current.easeTo({
      zoom: newZoom,
    })
  }
  return (
    <Button
      ref={ref}
      sx={{
        position: 'relative',
        backgroundColor: 'red',
        width: '48px',
        height: '48px',
        border: '1px solid',
        borderBottom: type === 'plus' ? '0px solid' : '1px solid',
        borderColor: 'black',
      }}
      onClick={handleClick}
    >
      {type === 'plus' && (
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate3d(-50%, -50%, 0)',
            width: '2px',
            height: '24px',
            backgroundColor: 'black',
          }}
        />
      )}
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate3d(-50%, -50%, 0)',
          width: '24px',
          height: '2px',
          backgroundColor: 'black',
        }}
      />
    </Button>
  )
})

export { ZoomControl }
